import { createContext } from 'react';
import { TImageField } from '../../../types/types';

export const NewsListingPlaceholderImgContext = createContext<TImageField | undefined>(undefined);
